import Amplify, { Auth } from 'aws-amplify';

import config from '../amplify/config.js';

// This can be used later for cached demo user sessions
export default sessions => {
  Amplify.configure(config)
  return Auth.signIn(sessions)
};
